import { Loader } from '@googlemaps/js-api-loader';

let googleApiLoader: Loader | null = null;

export function initializeGoogleMapsApi(apiKey: string) {
  if (!googleApiLoader) {
    googleApiLoader = new Loader({
      apiKey,
    });
  }
  return googleApiLoader;
}

export function getGoogleMapsLoader() {
  if (!googleApiLoader) {
    throw new Error('Google Maps API has not been initialized. Call initializeGoogleMapsApi first.');
  }
  return googleApiLoader;
}
